<template>
  <div class="searchBox">
    <div class="searchForm">
      <div class="searchItem">
        <label class="filter-label">类型：</label>
        <el-select v-model="search.keyList" filterable placeholder="请选择" size="medium">
          <el-option
            v-for="(item, index) in keyLists"
            :key="index"
            :label="item.text"
            :value="item.keyList">
          </el-option>
        </el-select>
      </div>

      <!-- <div class="searchItem">
        <label class="filter-label">类型：</label>
        <el-select :clearable="false" size="medium" v-model="search.typeId" placeholder="请选择">
          <el-option v-for="(type,index) in types"  :key="index" :label="type.label" :value="type.value"></el-option>
        </el-select>
      </div> -->

      <div class="searchItem">
        <label class="filter-label">状态：</label>
        <el-select :clearable="false" size="medium" v-model="search.handleStatus" placeholder="请选择">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div class="searchItem">
        <label class="filter-label">流程编号：</label>
        <el-input style="width: 200px" v-model="search.flowNo" size="medium"></el-input>
      </div>
      <div class="searchItem">
        <label class="filter-label">描述：</label>
        <el-input style="width: 200px" v-model="search.description" size="medium"></el-input>
      </div>
    </div>
    <div class="searchItem btn-group">
      <el-button size="medium"
          style="margin-left: 16px"
          @click="getAppSummaryList()"
          type="primary">查询
      </el-button>
      <el-button size="medium"
          style="margin-left: 16px"
          @click="reset()">重置
      </el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "searchBox",
    props:{
      statusList: {
        type:Array,
        default(){
          return []
        }
      }
    },
    data() {
      return {
        date: [],
        types:[
          { label: "全部", value: 0 },
          { label: "施工图申请", value: 1 },
          { label: "店铺效果图申请", value: 2 },
          { label: "平面图申请", value: 3 },
          { label: "围挡效果图申请", value: 4 },
          { label: "入职申请", value: 5 },
          { label: "入职流转申请", value: 6 },
          { label: "劳动合同申请", value: 7 },
          { label: "转正申请", value: 8 },
        ],
        shopList: [],
        search: {
          // typeId:0,// 记得改为0
          flowNo: "",
          handleStatus: null,
          keyList: '',
          description: ''
        },
        pickerOptions: {},
        keyLists: [],
      }
    },
    methods: {
      getExternalKey(){
        this.$api.dynamicForm.externalKey().then(({data}) => {
          this.keyLists = data;
        })
      },
      getAppSummaryList() {
        this.$emit("change")
      },
      getQuery(){
        return this.search
      },
      reset(){
        this.search =  {
          // typeId: 0,//  记得改为0
          flowNo: "",
          description: '',
          handleStatus: this.statusList[0].value,
        };
        this.getAppSummaryList()
      }
    },
    mounted() {
      this.search.handleStatus = this.statusList[0].value;
      this.getExternalKey();
    }
  }
</script>

<style scoped>
.filter-label{
  display: inline-block;
  height: 34px;
  line-height: 34px;
  width: 90px;
  text-align: right;
  margin-right: 10px;
}
.searchBox .btn-group{
  display: inline-block;
}
</style>
